import spbInvoiceApi from "@/service/api/SpbInvoiceApi";

const getBLDocuments = async (dbInstance, vendorId) => {
  return spbInvoiceApi.get(
    `/spb/invoiceproxy/nonpo/bldocuments/${dbInstance}/${vendorId}`
  );
};

const getBLTransactionDetails = async (payload) => {
  return spbInvoiceApi.post(`/spb/invoiceproxy/nonpo/bldetail`, payload);
};

export { getBLDocuments, getBLTransactionDetails };
